import React, { useEffect, useState } from "react";
import { Layout, Card, Table, Button, Spin, Descriptions } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { RollbackOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { postAPI, displayMessage } from "../../utils/common";
import { ERROR_MSG_TYPE } from "../../constants/messages";
import { KITCHEN_PURCHASE_RETURN_DETAIL } from "../../constants/api";

function KitchenPurchaseReturnView() {
  const { Content } = Layout;
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    getDetail();
  }, []);

  const getDetail = () => {
    setLoading(true);

    postAPI(
      KITCHEN_PURCHASE_RETURN_DETAIL,
      { id },
      (res) => {
        if (res.status) {
          setData(res.data);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to load data");
      },
    );
  };

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Item Code",
      dataIndex: ["item", "item_code"],
    },
    {
      title: "Item Name",
      dataIndex: ["item", "name"],
    },
    {
      title: "Purchased Qty",
      dataIndex: "purchased_qty",
    },
    {
      title: "Return Qty",
      dataIndex: "return_qty",
    },
    {
      title: "Rate",
      dataIndex: "rate",
      render: (v) => `₹ ${v}`,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (v) => `₹ ${v}`,
    },
    {
      title: "Reason",
      dataIndex: "reason",
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Store Purchase Return Detail"
          extra={
            <Button onClick={() => navigate(-1)}>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            {data && (
              <>
                {/* 🔹 Summary */}
                <Descriptions bordered size="small" column={2}>
                  <Descriptions.Item label="Return ID">
                    #{data.id}
                  </Descriptions.Item>

                  <Descriptions.Item label="Purchase ID">
                    #{data.purchase?.id}
                  </Descriptions.Item>

                  <Descriptions.Item label="Return Date">
                    {dayjs(data.return_date).format("DD MMM YYYY")}
                  </Descriptions.Item>

                  <Descriptions.Item label="Return By">
                    {data.return_by}
                  </Descriptions.Item>

                  <Descriptions.Item label="Total Amount">
                    ₹ {data.total_amount}
                  </Descriptions.Item>

                  <Descriptions.Item label="Remark">
                    {data.remark || "-"}
                  </Descriptions.Item>
                </Descriptions>

                {/* 🔹 Items */}
                <Table
                  columns={columns}
                  dataSource={data.items}
                  rowKey="id"
                  pagination={false}
                  style={{ marginTop: 20 }}
                />
              </>
            )}
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenPurchaseReturnView;
